export const SearchConf = {
  query: {
    keys: [
      {
        key: 'yacht_type',
        operator: '$containsi',
      },
      {
        key: 'yacht_name',
        operator: '$containsi',
      },
      {
        key: 'port_of_registry',
        operator: '$containsi',
      },
      {
        key: 'id',
        operator: '$containsi',
      },
      {
        key: 'registry_type',
        operator: '$containsi',
      },
      {
        key: 'id_flag.locality_flag',
        operator: '$containsi',
      },
      {
        key: 'registration_status',
        operator: '$containsi',
      },
    ],
  },
  placeholder:
    'Search by ID,name, type, registry, port of registry, flag or status',
  initialState: {
    value: '',
  },
};
